{
  "completed": "已完成：",
  "current": "目前：",
  "notCompleted": "未完成：",
  "steplist": "步驟清單"
}
